import { useEffect, useState } from "react";
import { getRejectedStep } from "../utils/general";
import notify from "../components/common/notify";

// Custom hook to handle errors during a flow
const useHandleFlowPopupError = ({
  flowPopupStatus, // Current status of the flow
  initialStatus,
  setFlowPopupStatus,
}) => {
  const [flowError, setFlowError] = useState(null);

  // Effect to handle the error when it occurs
  useEffect(() => {
    if (flowError) {
      handleFlowPopupError(flowError); // Handle the error
      setFlowError(null); // Reset the error
      setFlowPopupStatus(initialStatus); // Reset the flow status
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flowError, flowPopupStatus]);

  // Function to handle the error based on its type
  const handleFlowPopupError = (error) => {
    let errorMsg = getRejectedStep(flowPopupStatus).error; // Get the error message for the current step
    if (typeof error === "object") {
      if (error?.code === "ACTION_REJECTED") {
        // If the user canceled the step
        notify(`${errorMsg} \n Reason: You canceled this step!`, "error");
      } else {
        // If another error occurred
        notify(
          `${errorMsg} \n Reason: ${
            error?.reason ||
            error?.data?.reason ||
            error?.data?.message ||
            error?.message ||
            "NETWORK CONNECTION FAILED!"
          }`,
          "error"
        );
      }
    }
  };

  return {
    handleFlowPopupError,
    flowError,
    setFlowError,
  };
};

export default useHandleFlowPopupError;
